import { useAuth } from '../contexts/AuthContext';
import { isFeatureFlagEnabled } from '../utils/feature-flags';

export function useFeatureFlag(flagKey: string): boolean {
  const { user } = useAuth();
  return isFeatureFlagEnabled(user?.featureFlags, flagKey);
}
